import { format } from "date-fns";

export const COLUMNS = [
  {
    Header: "Date",
    accessor: "HolidayDate",
    Cell: ({ cell }) => {
      const { value } = cell;
      if (value !== null && typeof value !== "undefined") {
        const date = new Date(value)
          .toISOString()
          .substr(0, 10)
          .split("-");
        return format(
          new Date(date[0], parseInt(date[1]) - 1, date[2]),
          "MM/dd/yyyy"
        );
      }
      return "N/A";
    }
  },
  {
    Header: "Description",
    accessor: "HolidayDescription"
  }
];
